export default {
  "pages.login.title": "Login",
  "pages.login.intro": "You need to log in to access Watamusic.",
  "pages.home.title": "Home",
  "pages.albums.title": "Products",
  "pages.albums.create.title": "Add a product",
  "pages.tracks.title": "Tracks",
  "pages.artists.title": "Artists",
  "pages.not-found.title": "Page not found",
  "pages.statements.title": "Statements",
  "pages.reports.title": "Reports",
  "pages.reports.create.title": "Generate report",
  "pages.users.title": "Users",
  "pages.users.create.title": "Create User",
  "pages.deliveries.title": "Deliveries",
  "pages.deliveries.intro": "Keep track of delivery activity across each service provider.",
  "pages.bundles.title": "Bundles",
  "pages.statistics.title": "Statistics",
  "pages.bundles.create.title": "Upload new bundle",
  "pages.search.title": "Search results",
  "pages.playlists.title": "Playlists",
  "home.welcome-user": "Welcome, {name}",
  "nav.bundles.title": "From bundle",
  "nav.albums.create-title": "Add a product",
  "copyright": "© 2025 Modulor / Watamusic",
  "not-found.title": "404 - Page Not Found",
  "not-found.description": "Sorry, the page you are looking for does not exist.",
  "ui.async.loading": "Loading",
  "ui.button.download": "Download",
  "api.general.file-upload": "File upload",
  "api.button.download-ext": "Download [.{ext}]",
  "auth.action.logout": "Log out",
  "users.blurb": "Create and manage users across your organisation",
  "users.create.button": "Create a new user",
  "auth.login.email": "Email",
  "auth.login.password": "Password",
  "auth.login.login": "Login",
  "users.user.entity_singular": "User",
  "users.user.entity_plural": "Users",
  "users.user.entity_definite_article": "the user",
  "users.user.entity_demonstrative": "this user",
  "users.user.entity_indefinite_article": "a user",
  "users.columns.name": "Name",
  "users.columns.email": "Email",
  "users.columns.password": "Password",
  "users.columns.organisation": "Organisation",
  "users.columns.roles": "Roles",
  "users.columns.created_at": "Created",
  "users.columns.updated_at": "Updated",
  "charts.title": "Charts",
  "charts.no-rows": "There are no rows for this chart.",
  "charts.num-streams": "{number} {total, plural,\n            =0 {streams}\n            one {stream}\n            other {streams}\n        }",
  "charts.num-downloads": "{number} {total, plural,\n            =0 {downloads}\n            one {download}\n            other {downloads}\n        }",
  "charts.new-releases-popover-title": "New releases",
  "charts.new-releases-description": "New releases are defined as products released within 8 weeks of the selected date period.",
  "charts.chart.stream-tracks-week": "Most streamed tracks of the week",
  "charts.chart.stream-tracks-alltime": "Most streamed tracks of all time",
  "charts.chart.download-tracks-week": "Most downloaded tracks of the week",
  "charts.chart.download-tracks-alltime": "Most downloaded tracks of all time",
  "charts.chart.download-albums-week": "Most downloaded products of the week",
  "charts.chart.download-albums-alltime": "Most downloaded products of all time",
  "charts.chart.stream-tracks-period": "Most streamed tracks",
  "charts.chart.stream-newreleases-period": "Most streamed new releases",
  "charts.chart.download-tracks-period": "Most downloaded tracks",
  "charts.chart.download-albums-period": "Most downloaded products",
  "charts.chart.preorders-period": "Most pre-ordered products",
  "charts.chart.stream-artists-period": "Most streamed artists",
  "deliveries.general.load-more-deliveries": "Load more deliveries",
  "deliveries.settings.type-filter": "Filter by type",
  "deliveries.settings.status-type-filter": "Filter by status type",
  "deliveries.type.insert": "Full new",
  "deliveries.type.full-update": "Full update",
  "deliveries.type.full-takedown": "Full takedown",
  "deliveries.type.update-tracks": "Update tracks",
  "deliveries.type.update-metadata": "Update metadata",
  "deliveries.type.update-deal": "Update deal",
  "deliveries.status_type.selected": "Selected",
  "deliveries.status_type.scheduled-delivery": "Scheduled delivery",
  "deliveries.status_type.delivery-in-progress": "Delivery in progress",
  "deliveries.status_type.delivered": "Delivered",
  "deliveries.status_type.error": "Error",
  "deliveries.status_type.cancelled": "Cancelled",
  "deliveries.status_type.not-available": "Not available",
  "deliveries.status_type.available": "Available",
  "deliveries.delivery.entity_singular": "Delivery",
  "deliveries.delivery.entity_plural": "Deliveries",
  "deliveries.delivery.entity_definite_article": "the delivery",
  "deliveries.delivery.entity_demonstrative": "this delivery",
  "deliveries.delivery.entity_indefinite_article": "a delivery",
  "deliveries.delivery.columns.album": "Album",
  "deliveries.delivery.columns.upc": "UPC/EAN",
  "deliveries.delivery.columns.dsp": "DSP",
  "deliveries.delivery.columns.type": "Type",
  "deliveries.delivery.columns.status": "Status",
  "deliveries.delivery.columns.batch": "Batch",
  "deliveries.delivery.columns.created_at": "Created",
  "deliveries.delivery.columns.updated_at": "Updated",
  "deliveries.status.columns.type": "Type",
  "deliveries.status.columns.occurred_at": "Occurred",
  "deliveries.batch.columns.name": "Batch name",
  "deliveries.batch.columns.file_structure": "Files",
  "dsps.settings.dsps-filter": "Filter by DSP",
  "files.file.entity_singular": "File",
  "files.file.entity_plural": "Files",
  "files.file.entity_definite_article": "the file",
  "files.file.entity_demonstrative": "this file",
  "files.file.entity_indefinite_article": "a file",
  "localisation.lang.en": "English",
  "localisation.lang.fr": "French",
  "localisation.country.entity_singular": "Country",
  "localisation.country.entity_plural": "Countries",
  "localisation.country.entity_definite_article": "the country",
  "localisation.country.entity_demonstrative": "this country",
  "localisation.country.entity_indefinite_article": "a country",
  "localisation.region.entity_singular": "Region",
  "localisation.region.entity_plural": "Regions",
  "localisation.region.entity_definite_article": "the region",
  "localisation.region.entity_demonstrative": "this region",
  "localisation.region.entity_indefinite_article": "a region",
  "localisation.region.columns.code": "Region code",
  "music.settings.albums-filter": "Filter by album",
  "music.general.new-artist": "New artist",
  "music.general.draft": "Draft",
  "music.general.archived": "Archived",
  "music.no-albums-title": "You haven’t created any products yet",
  "music.no-albums": "Add a product to get started",
  "music.products.add": "Add a product",
  "music.latest-albums": "Latest products created",
  "music.product-information": "Product information",
  "music.track-information": "Track information",
  "music.album.links": "Linkfire and playlists",
  "music.album.links-description": "Here you will find the pre-save link to share the release on your socials,\nas well as the playlists obtained on Monday after the release, before 1 PM.",
  "music.album.entity_singular": "Product",
  "music.album.entity_plural": "Products",
  "music.album.entity_definite_article": "the product",
  "music.album.entity_demonstrative": "this product",
  "music.album.entity_indefinite_article": "a product",
  "music.album.columns.title": "Title",
  "music.album.columns.title_version": "Title version",
  "music.album.columns.upc": "UPC/EAN",
  "music.album.columns.custom_id": "Catalog number",
  "music.album.columns.original_release_date": "Original release date",
  "music.album.columns.preorder_date": "Pre-order date",
  "music.album.columns.release_date": "Release date",
  "music.album.columns.comment": "Comment",
  "music.album.columns.comment-private": "Private comment",
  "music.album.columns.preorder-preview": " Preview during pre-order period",
  "music.album.columns.genre": "Genre",
  "music.album.columns.additional-genre": "Additional genre",
  "music.album.columns.label": "Label",
  "music.album.columns.price": "Price",
  "music.album.columns.track-price": "Track price",
  "music.album.columns.created_at": "Created",
  "music.album.columns.updated_at": "Updated",
  "music.track.entity_singular": "Track",
  "music.track.entity_plural": "Tracks",
  "music.track.entity_definite_article": "the track",
  "music.track.entity_demonstrative": "this track",
  "music.track.entity_indefinite_article": "a track",
  "music.track.columns.title": "Title",
  "music.track.columns.title_version": "Title version",
  "music.track.columns.isrc": "ISRC",
  "music.track.columns.duration": "Duration",
  "music.track.columns.explicit": "Explicit",
  "music.track.columns.gapless": "Gapless",
  "music.track.columns.copyright": "Copyright",
  "music.track.columns.artists": "Artist(s)",
  "music.track.columns.albums": "Albums",
  "music.track.columns.created_at": "Created",
  "music.track.columns.updated_at": "Updated",
  "music.track.columns.genre": "Genre",
  "music.track.columns.label": "Label",
  "music.artist.entity_singular": "Artist",
  "music.artist.entity_plural": "Artists",
  "music.artist.entity_definite_article": "the artist",
  "music.artist.entity_demonstrative": "this artist",
  "music.artist.entity_indefinite_article": "an artist",
  "music.album_track.columns.disc": "Disc",
  "music.album_track.columns.track": "Track",
  "music.album_track.columns.album_only": "Album only",
  "music.album_track.columns.preorder_date": "Pre-order date",
  "music.album_track.columns.release_date": "Release date",
  "music.label.entity_singular": "Label",
  "music.label.entity_plural": "Labels",
  "music.label.entity_definite_article": "the label",
  "music.label.entity_demonstrative": "this label",
  "music.label.entity_indefinite_article": "an label",
  "music.label.columns.name": "Name",
  "pages.report.intro": "Locate and download your monthly statements.",
  "pages.report.info": "Since January 2024, Modulor only retains records for two years plus the current year.<br></br>\nStatements are available from 2023 only.",
  "reports.menu.financial": "Financial",
  "reports.custom_reports.intro": "Generate and download custom financial reports",
  "reports.custom_reports.generate-button": "Generate a new report",
  "reports.custom_reports.info": "Only one custom report can be generated at a time using the \"Create Report\" form.<br></br>\nYou can generate a summary report with the total for each platform or a detailed report for all platforms over\nthe chosen period.<br></br>\nReports can be generated for a period of up to two years plus the current year.",
  "reports.custom_reports.in_progress_error": "You may only generate one report at once.",
  "reports.statement_singular": "Statement",
  "reports.statementPlural": "Statements",
  "reports.report.entity_singular": "Report",
  "reports.report.entity_plural": "Reports",
  "reports.report.columns.period": "Period",
  "reports.report.columns.description": "Description",
  "reports.report.columns.status": "Status",
  "reports.report.columns.type": "Type",
  "reports.report.columns.generated_by": "Generated By",
  "reports.report.columns.created_at": "Created",
  "reports.report.columns.updated_at": "Updated",
  "reports.table.month": "Month",
  "reports.table.last_updated": "Last updated",
  "reports.table.number_rows": "Number of rows",
  "reports.table.amount_payable": "Amount payable",
  "reports.table.download": "Download",
  "reports.general.load-more-reports": "Load more reports",
  "reports.general.load-more-statements": "Load more statements",
  "sales.general.load-more-playlists": "Load more playlists",
  "sales.title": "Trends",
  "sales.title.performance": "Performance",
  "sales.info-popover.title": "Note",
  "sales.info-popover.body": "<p>The maximum range you can search on is {days} days.\n If you need data for a larger range, please contact {provider}.</p>\n<p>YouTube trends may not be reflective of the final views shown in statements.\n These trends figures should be treated as a guide only.</p>",
  "sales.playlist-trends.title": "Playlist trends",
  "sales.playlist-trends.table.total": "Total streams",
  "sales.playlist-trends.table.tracks": "Tracks",
  "sales.title.gender": "Gender breakdown",
  "sales.title.age": "Age breakdown",
  "sales.title.region": "Region breakdown",
  "sales.small.gender": "Data sourced from Spotify and Apple Music only and may not match the figures above exactly.",
  "sales.streams": "Streams",
  "sales.downloads": "Downloads",
  "sales.total": "Total",
  "sales.num-streams": "{number} {total, plural,\n            =0 {streams}\n            one {stream}\n            other {streams}\n        }",
  "sales.num-downloads": "{number} {total, plural,\n            =0 {downloads}\n            one {download}\n            other {downloads}\n        }",
  "sales.total-streams": "Total streams over this period: {number} {total, plural,\n            =0 {streams}\n            one {stream}\n            other {streams}\n        }",
  "sales.total-streams-of-total": "Total streams over this period: {number} {total, plural,\n            =0 {streams}\n            one {stream}\n            other {streams}\n        } ({percent} of total)",
  "sales.total-streams-no-value": "Total streams over this period",
  "sales.total-streams-period": "Total streams over {period}",
  "sales.period.last-n-days": "the last {n} days",
  "sales.total-downloads": "Total downloads over this period: {number} {total, plural,\n            =0 {downloads}\n            one {download}\n            other {downloads}\n        }",
  "sales.total-downloads-of-total": "Total downloads over this period: {number} {total, plural,\n            =0 {downloads}\n            one {download}\n            other {downloads}\n        } ({percent} of total)",
  "sales.total-downloads-no-value": "Total downloads over this period",
  "sales.label.country": "Country",
  "sales.graph.album-download": "Album downloads",
  "sales.graph.track-download": "Track downloads",
  "sales.graph.itunes-album-download": "iTunes albums",
  "sales.graph.itunes-track-download": "iTunes tracks",
  "sales.graph.track-stream": "Track streams",
  "sales.graph.am-stream": "Apple Music",
  "sales.graph.spotify-stream": "Spotify",
  "sales.graph.deezer-stream": "Deezer",
  "sales.graph.napster-stream": "Napster",
  "sales.graph.youtube-stream": "YouTube",
  "sales.graph.youtube-subscription-stream": "YouTube Premium",
  "sales.graph.youtube-ad-stream": "YouTube Ad",
  "sales.graph.amazon-stream": "Amazon",
  "sales.graph.amazon-album-download": "Amazon albums",
  "sales.graph.amazon-track-download": "Amazon tracks",
  "sales.settings.country-filter": "Filter by country",
  "sales.presets.last-30-days": "Last 30 days",
  "sales.presets.this-week": "This week",
  "sales.presets.last-week": "Last week",
  "sales.presets.previous-week": "Previous week",
  "sales.presets.this-month": "This month",
  "sales.presets.last-month": "Last month",
  "sales.presets.previous-month": "Previous month",
  "sales.presets.last-3-months": "Last 3 months",
  "sales.presets.previous-3-months": "Previous 3 months",
  "sales.presets.since-release-date": "Since Release Date",
  "sales.gender.male": "Male",
  "sales.gender.female": "Female",
  "sales.gender.unknown": "Unknown",
  "sales.gender.neutral": "Neutral",
  "sales.age-group.unknown": "Unknown",
  "sales.plus-additional-tracks": "+ Plus {number, plural,\n            =0 {no additional tracks}\n            one {# additional track}\n            other {# additional tracks}\n        }",
  "sales.number-streams": "# streams",
  "sales.headline-stats.new-releases": "Streams from new releases",
  "sales.headline-stats.whole-catalogue": "Streams of whole catalogue",
  "sales.headline-stats.playlists": "Streams from playlists",
  "sales.headline-stats.tracked-playlists": "Streams from tracked playlists",
  "sales.dsp-streams-chart.title": "Streams by source",
  "sales.dsp-downloads-chart.title": "Downloads by source",
  "sales.geo-chart.title": "Performance by country",
  "search.form.placeholder": "Search",
  "search.form.placeholder-focused": "Search for albums by title, UPC/EAN, etc.",
  "search.results.title": "Search results for \"{query}\"",
  "search.results.found": "Found {total, plural,\n            =0 {no results}\n            other {{albums, plural,\n                =0 {}\n                one {one product}\n                other {# products}\n            } {tracks, plural,\n                =0 {}\n                one { {albums, plural, =0 {} other {and}} one track}\n                other { {albums, plural, =0 {} other {and}} # tracks}\n            }}\n        }",
  "search.results.error": "You must enter a search query.",
  "ui.pages.home": "Home",
  "ui.dates.day": "Day",
  "ui.dates.month": "Month",
  "ui.dates.year": "Year",
  "ui.dates.start": "Start Date",
  "ui.dates.end": "End Date",
  "ui.async.load-more": "Load more",
  "ui.button.create": "Create",
  "ui.button.edit": "Edit",
  "ui.button.update": "Update",
  "ui.button.delete": "Delete",
  "ui.button.download-csv": "Download CSV",
  "ui.button.yes": "Yes",
  "ui.button.no": "No",
  "ui.button.show-more": "Show more",
  "ui.button.show-fewer": "Show fewer",
  "ui.select.add_label": "Add \"{label}\"?",
  "ui.select.clear_all": "Clear all",
  "ui.select.clear_value": "Clear value",
  "ui.select.no_results": "No results found",
  "ui.select.placeholder": "Select...",
  "ui.select.search_prompt": "Type to search",
  "ui.select.loading": "Loading...",
  "ui.phrases.create_entity": "Create {entity}",
  "ui.phrases.edit_entity": "Edit {entity}",
  "ui.phrase.delete_entity": "Delete {entity}",
  "ui.phrase.delete_entity_long": "Are you sure you want to delete {entity}, \"{name}\"?",
  "table.manage": "Manage",
  "table.filter": "Filter",
  "table.reset-filters": "Reset filters",
  "table.filter-placeholder": "Start typing to filter...",
  "pagination.next": "Next",
  "pagination.previous": "Previous",
  "upload.general.load-more-bundles": "Load more bundles",
  "upload.general.upload-new-bundle": "Upload new bundle",
  "upload.general.download-empty-metadata": "Download empty metadata file",
  "upload.general.upload-metadata": "Upload metadata",
  "upload.general.upload": "Upload",
  "upload.general.reupload-metadata": "Re-upload metadata",
  "upload.general.view-update": "View/update",
  "upload.general.uploaded-by": "Uploaded by {name}",
  "upload.general.album-preview": "Album preview",
  "upload.general.create-album": "Create album",
  "upload.general.update-album": "Update album",
  "upload.general.upload-zip": "Upload zip",
  "upload.general.reupload-zip": "Re-upload zip",
  "upload.general.confirmation": "Confirmation",
  "upload.general.complete": "Complete",
  "upload.instructions.upload-1": "To upload a new album bundle, you must download the empty\n metadata file and fill in the fields of the spreadsheet.",
  "upload.instructions.upload-2": "Once done, use the upload button to start the upload process.",
  "upload.instructions.upload-3": "To download the non-macro spreadsheet <link>click here</link>.",
  "upload.instructions.create-album-1": "Below is a preview of the album that will be created.",
  "upload.instructions.create-album-2": "Check carefully that all information is as expected and\n pay close attention as to whether artists will be created.",
  "upload.instructions.create-album-3": "If the above looks correct, click the button below create the album and artists, if relevant.",
  "upload.instructions.upload-zip-1": "Next you need to upload a zip file containing the following files:",
  "upload.instructions.upload-zip-list-1": "A JPG or PNG file for the artwork. Typically this should be a 3000x3000 RGB JPG file.\n Note: this can't contain embedded profiles.",
  "upload.instructions.upload-zip-list-2": "A FLAC or WAV file for each track on the release.\n The filename must be prefixed with <strong>''[disc]_[track]_''</strong>\n so they can be matched to the corresponding track. eg the audio for track 4 on\n disc 2 might have the filename <strong>''2_4_tracktitle.wav''</strong>.",
  "upload.instructions.upload-zip-list-3": "An optional PDF file for the booklet.",
  "upload.instructions.complete-1": "To complete the upload of the bundle and create the album,\n you just need to confirm that you want to continue. Once done, the audio will begin\n to be processed so this could take some time.",
  "upload.instructions.complete-2": "Note",
  "upload.instructions.complete-3": "The complete action is final and, once done, you won't\n be able to return to previous steps to re-upload metadata nor content. Click to\n complete once you're sure everything is as expected. Also give plenty of time\n for the album to be sent to the DSPs, typically at least a week before release.",
  "upload.instructions.error-1": "The bundle is in an error state after the last action.\n Please contact support to resolve the issues.",
  "upload.instructions.error-2": "The following errors were reported:",
  "upload.bundle.default-title": "Bundle {id}",
  "upload.bundle.entity_singular": "Bundle",
  "upload.bundle.entity_plural": "Bundles",
  "upload.bundle.entity_definite_article": "the bundle",
  "upload.bundle.entity_demonstrative": "this bundle",
  "upload.bundle.entity_indefinite_article": "a bundle",
  "upload.bundle.columns.attrs": "Attributes",
  "upload.bundle.columns.errors": "Errors",
  "upload.bundle.columns.status": "Status",
  "upload.bundle.columns.album": "Album",
  "upload.bundle.columns.user": "Uploaded by",
  "upload.bundle.columns.created_at": "Created",
  "upload.bundle.columns.updated_at": "Updated",
  "validation.mesages.required": "The {column} field is required.",
  "validation.mesages.min_length": "The {column} must be at least {min} characters long.",
  "validation.mesages.max_length": "The {column} may not be greater than {max} characters long.",
  "validation.mesages.email": "The {column} must be a valid email.",
  "validation.mesages.min": "The {column} must be at least {min}.",
  "validation.mesages.max": "The {column} may not be greater than {max}.",
  "validation.mesages.pattern": "The {column} must match the pattern {pattern}.",
  "validation.mesages.equal_to": "The {column} must match {match}.",
  "validation.mesages.one_of": "The {column} must be one of {matches}.",
  "validation.mesages.url": "The {column} is not a valid URL.",
  "vendor.settings.playlists-filter": "Select a playlist",
  "vendor.settings.snapshot_taken": "Snapshot taken on {date}",
  "vendor.settings.go_to_track": "Go to track",
  "vendor.settings.go_to_playlist": "Go to playlist",
  "vendor.settings.no_snapshots": "There are no snapshots to show.",
  "vendor.title.tracks_on_playlists": "Tracks currently on playlists",
  "vendor.playlist.default-title": "Playlist {id}",
  "vendor.playlist.entity_singular": "Playlist",
  "vendor.playlist.entity_plural": "Playlists",
  "vendor.playlist.entity_definite_article": "the playlist",
  "vendor.playlist.entity_demonstrative": "this playlist",
  "vendor.playlist.entity_indefinite_article": "a playlist",
  "vendor.playlist.columns.meta.owner": "Created by",
  "vendor.playlist.listen_on": "Listen on {vendor}",
  "vendor.playlist-snapshot.entity_singular": "Playlist snapshot",
  "vendor.playlist-snapshot.entity_plural": "Playlist snapshots",
  "vendor.playlist-snapshot.entity_definite_article": "the playlist snapshot",
  "vendor.playlist-snapshot.entity_demonstrative": "this playlist snapshot",
  "vendor.playlist-snapshot.entity_indefinite_article": "a playlist snapshot",
  "vendor.playlist-snapshot.columns.num_followers": "Number of followers",
  "vendor.playlist-snapshot.columns.meta.updated_at": "Updated at",
  "vendor.playlist-snapshot.columns.num_owned_tracks": "Catalog tracks on playlist",
  "vendor.track.entity_singular": "Track",
  "vendor.track.entity_plural": "Tracks",
  "vendor.track.entity_definite_article": "the track",
  "vendor.track.entity_demonstrative": "this track",
  "vendor.track.entity_indefinite_article": "a track",
  "vendor.track.columns.title": "Title",
  "vendor.track.columns.artists": "Artist(s)",
  "vendor.track.columns.album": "Album",
  "vendor.track.columns.isrc": "ISRC",
  "vendor.track.columns.vendor": "Service",
  "vendor.track.columns.playlists": "Playlists",
  "vendor.playlist-snapshot-track.columns.added_at": "Added"
};